import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';
import {
  ReportRecord,
  ReportInfo,
  ReportOptions,
  RecordUpdateEmission,
  TemplateProjectionMap,
} from '../../models/report.model';
import { RawColumn } from '../../models/template.model';
import { DataViewToolbarComponent } from './data-view-toolbar/data-view-toolbar.component';
import { DataViewTableComponent } from './data-view-table/data-view-table.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'rep-data-view',
  templateUrl: './data-view.component.html',
  imports: [DataViewToolbarComponent, DataViewTableComponent],
})
export class DataViewComponent {
  readonly reportData = input.required<ReportInfo>();
  readonly reportOptions = input.required<ReportOptions>();
  readonly displayedColumns = input.required<RawColumn[]>();
  readonly defaultColumns = input.required<RawColumn[]>();
  readonly reportLocale = input.required<number>();
  readonly templateProjectionMap = input.required<TemplateProjectionMap>();
  readonly isUKFeaturesEnabled = input<boolean>(false);

  readonly removeRecord = output<ReportRecord>();
  readonly reportReordered = output<ReportRecord[]>();
  readonly customizeColumns = output<string>();
  readonly reportUpdateClick = output<RecordUpdateEmission>();
  readonly reorderReportColumns = output<number[]>();

  removeRecordFromReport(reportItem) {
    const recordId = reportItem.recordId ? reportItem.recordId : reportItem.data.recordId;
    this.removeRecord.emit({ ...reportItem, recordId });
  }
}
